import { createContext, useContext } from 'react';

/**
 * The tenant's own dispatch dashboard — `GET /meta` → `dashboardUrl`, from
 * dispatch's `public.tenants.admin_base_url` — which the STANDALONE console
 * links a job number at (see screens/comms/booking/dispatchLink.ts for the
 * order of the answers; framed, the parent's own origin wins).
 *
 * Provided by CapabilitiesProvider off the /meta read it already makes, so
 * knowing it costs no request of its own. Null until that lands, when it
 * failed, on a service that predates the field, and wherever dispatch records
 * no dashboard — and null renders every reference as plain text.
 */
export const TenantDashboardContext = createContext<string | null>(null);

export const useTenantDashboardUrl = (): string | null => useContext(TenantDashboardContext);
